import script from "./AppNotificationContentType.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotificationContentType.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotificationContentType.vue?vue&type=style&index=0&id=430f3d32&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430f3d32"]])

export default __exports__